import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/AppShell';
import { TagView } from '@/features/tags/TagView';

export const Route = createFileRoute('/tags/$id')({
  component: TagPage,
});

function TagPage() {
  const { id } = Route.useParams();
  return (
    <AppShell>
      <TagView tagId={id} />
    </AppShell>
  );
}
